module.exports = __webpack_public_path__ + "a179ed9dab7aa0d43762f27f8b7fe7c9.png";